export default __webpack_public_path__ + "static/media/cadreme.eda9860c.png";